"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _defaultTheme = _interopRequireDefault(require("../defaultTheme"));
var _FormLabel = _interopRequireDefault(require("../FormLabel"));
var _InputField = require("../InputField");
var _Select = require("../Select");
var _ErrorFormTooltip = _interopRequireDefault(require("../ErrorFormTooltip"));
var _consts = require("./consts");
var _rtl = require("../utils/rtl");
var _getSpacingToken = _interopRequireDefault(require("../common/getSpacingToken"));
var _useRandomId = _interopRequireWildcard(require("../hooks/useRandomId"));
var _formElementFocus = _interopRequireDefault(require("../InputField/helpers/formElementFocus"));
var _getFieldDataState = _interopRequireDefault(require("../common/getFieldDataState"));
var _mediaQuery = _interopRequireDefault(require("../utils/mediaQuery"));
const getToken = name => ({
  theme,
  size
}) => {
  const tokens = {
    [_consts.TOKENS.height]: {
      [_consts.SIZE_OPTIONS.SMALL]: theme.orbit.heightInputSmall,
      [_consts.SIZE_OPTIONS.NORMAL]: theme.orbit.heightInputNormal
    },
    [_consts.TOKENS.heightLine]: {
      [_consts.SIZE_OPTIONS.SMALL]: "16px",
      [_consts.SIZE_OPTIONS.NORMAL]: "24px"
    }
  };
  if (!size) return null;
  return tokens[name][size];
};
const FakeGroup = _styledComponents.default.span.withConfig({
  displayName: "InputGroup__FakeGroup",
  componentId: "sc-x6vk15-0"
})(["", ""], ({
  theme,
  $error,
  $disabled,
  $active
}) => (0, _styledComponents.css)(["width:100%;display:block;z-index:1;box-sizing:border-box;height:", ";box-shadow:", ";box-shadow:", ";", ";background-color:", ";font-size:", ";transition:box-shadow ", " ease-in-out;border-radius:6px;", ";&:hover{box-shadow:", ";}"], getToken(_consts.TOKENS.height), `inset 0 0 0 ${theme.orbit.borderWidthInput} ${theme.orbit.borderColorInput}`, $error && `inset 0 0 0 ${theme.orbit.borderWidthInput} ${theme.orbit.borderColorInputError}`, $active && _formElementFocus.default, $disabled ? theme.orbit.backgroundInputDisabled : theme.orbit.backgroundInput, theme.orbit.fontSizeInputNormal, theme.orbit.durationFast, _mediaQuery.default.tablet((0, _styledComponents.css)(["border-radius:", ";"], theme.orbit.borderRadiusNormal)), !$disabled && `inset 0 0 0 ${theme.orbit.borderWidthInput} ${$error ? theme.orbit.borderColorInputErrorHover : theme.orbit.borderColorInputHover}`));
FakeGroup.defaultProps = {
  theme: _defaultTheme.default
};
const StyledChildren = _styledComponents.default.div.withConfig({
  displayName: "InputGroup__StyledChildren",
  componentId: "sc-x6vk15-1"
})(["display:flex;position:relative;"]);
const StyledChild = _styledComponents.default.div.withConfig({
  displayName: "InputGroup__StyledChild",
  componentId: "sc-x6vk15-2"
})(["flex:", ";padding:", ";:last-child{padding:0;}"], ({
  flex
}) => flex, ({
  theme
}) => (0, _rtl.rtlSpacing)(`0 ${theme.orbit.spaceXSmall} 0 0`));
StyledChild.defaultProps = {
  theme: _defaultTheme.default
};
const StyledInputGroup = (0, _styledComponents.default)(({
  children,
  className,
  dataTest,
  id,
  role,
  ariaLabelledby,
  forwardRef,
  dataState
}) => /*#__PURE__*/React.createElement("div", {
  "data-state": dataState,
  ref: forwardRef,
  id: id,
  className: className,
  "data-test": dataTest,
  role: role,
  "aria-labelledby": ariaLabelledby
}, children)).withConfig({
  displayName: "InputGroup__StyledInputGroup",
  componentId: "sc-x6vk15-3"
})(["display:flex;width:100%;flex-direction:column;position:relative;margin-bottom:", ";", "{", "{box-shadow:none;background-color:transparent;display:none;align-items:center;justify-content:flex-end;}", "{background-color:transparent;> select{box-shadow:none;background-color:transparent;&:focus{outline:none;}}}", ":after,", ":after{content:\" \";position:absolute;top:50%;transform:translateY(-50%);", ":0;height:", ";width:1px;background-color:", ";transition:background-color ", " ease-in-out;display:block;z-index:2;}&:last-of-type{", ":after,", ":after{content:none;}}}", " ", "{display:", ";}", ":focus ~ ", "{box-shadow:none;}"], _getSpacingToken.default, StyledChild, _InputField.FakeInput, _Select.SelectContainer, _InputField.InputContainer, _Select.SelectContainer, _rtl.right, getToken(_consts.TOKENS.heightLine), ({
  theme,
  error,
  active
}) => error && !active ? theme.orbit.borderColorInputError : theme.orbit.borderColorInput, ({
  theme
}) => theme.orbit.durationFast, _InputField.InputContainer, _Select.SelectContainer, StyledChild, _FormLabel.default, ({
  label
}) => label && "none", _InputField.Input, _InputField.FakeInput);
StyledInputGroup.defaultProps = {
  theme: _defaultTheme.default
};
const findPropInChild = (propToFind, children) => React.Children.map(children, el => {
  if (el.props && el.props[propToFind]) return el.props[propToFind];
  return null;
}).filter(el => el != null);
const InputGroup = /*#__PURE__*/React.forwardRef(({
  children,
  label,
  flex,
  size = _consts.SIZE_OPTIONS.NORMAL,
  help,
  id,
  error,
  disabled,
  dataTest,
  spaceAfter,
  helpClosable = true,
  onFocus,
  onBlur,
  onChange,
  onBlurGroup
}, ref) => {
  const [active, setActive] = React.useState(false);
  const [filled, setFilled] = React.useState(false);
  const inputID = (0, _useRandomId.default)();
  const [tooltipShown, setTooltipShown] = React.useState(false);
  const [tooltipShownHover, setTooltipShownHover] = React.useState(false);
  const labelRef = React.useRef(null);
  const iconRef = React.useRef(null);
  const foundErrors = findPropInChild("error", children);
  const foundHelp = findPropInChild("help", children);
  const errorReal = error || foundErrors.length > 0 && foundErrors[0];
  const helpReal = help || foundHelp.length > 0 && foundHelp[0];
  const randomId = (0, _useRandomId.useRandomIdSeed)();
  const isFilled = React.useCallback(() => setFilled(findPropInChild("value", children).length > 0), [children]);
  React.useEffect(() => {
    isFilled();
  }, [isFilled, label]);
  const handleFocus = callBack => ev => {
    setActive(true);
    setTooltipShown(true);
    if (onFocus) onFocus(ev);
    if (callBack) callBack(ev);
  };
  const handleBlur = callBack => ev => {
    isFilled();
    setActive(false);
    if (onBlur) onBlur(ev);
    if (callBack) callBack(ev);
  };
  const handleChange = callBack => ev => {
    isFilled();
    if (onChange) onChange(ev);
    if (callBack) callBack(ev);
  };
  const handleBlurGroup = ev => {
    ev.persist();
    if (onBlurGroup) {
      setTimeout(() => {
        setActive(isActive => {
          if (!isActive) {
            onBlurGroup(ev);
          }
          return isActive;
        });
      }, 50);
    }
  };
  return /*#__PURE__*/React.createElement(StyledInputGroup, {
    label: label,
    error: errorReal,
    active: active,
    size: size,
    forwardRef: ref,
    dataTest: dataTest,
    id: id,
    dataState: (0, _getFieldDataState.default)(!!errorReal),
    spaceAfter: spaceAfter,
    role: "group",
    ariaLabelledby: label && inputID
  }, label && /*#__PURE__*/React.createElement(_FormLabel.default, {
    filled: filled,
    id: inputID,
    labelRef: labelRef,
    error: !!errorReal,
    help: !!helpReal,
    iconRef: iconRef,
    onMouseEnter: () => setTooltipShownHover(true),
    onMouseLeave: () => setTooltipShownHover(false)
  }, label), /*#__PURE__*/React.createElement(FakeGroup, {
    $label: label,
    $error: errorReal,
    $active: active,
    $size: size,
    $disabled: disabled
  }, /*#__PURE__*/React.createElement(StyledChildren, {
    onBlur: handleBlurGroup
  }, React.Children.toArray(children).map((child, key) => {
    const childFlex = Array.isArray(flex) && flex.length !== 1 ? flex[key] || flex[0] : flex;
    const item = child;
    return /*#__PURE__*/React.createElement(StyledChild, {
      flex: childFlex || "0 1 auto",
      key: randomId(String(key))
    }, /*#__PURE__*/React.cloneElement(item, {
      disabled: item.props.disabled || disabled,
      size,
      label: undefined,
      onChange: handleChange(item.props.onChange),
      onBlur: handleBlur(item.props.onBlur),
      onFocus: handleFocus(item.props.onFocus),
      // @ts-expect-error custom prop
      insideInputGroup: true
    }));
  }))), /*#__PURE__*/React.createElement(_ErrorFormTooltip.default, {
    help: helpReal,
    error: errorReal,
    helpClosable: helpClosable,
    inputSize: size,
    onShown: setTooltipShown,
    shown: tooltipShown || tooltipShownHover,
    referenceElement: labelRef
  }));
});
InputGroup.displayName = "InputGroup";
var _default = InputGroup;
exports.default = _default;